import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, XOctagon, TrendingDown } from 'lucide-react';
export function PainSection() {
  const painPoints = [{
    icon: <XOctagon className="w-8 h-8 text-neon-red" data-id="element-103" />,
    text: 'Entrenás fuerte pero fallás por agarre',
    desc: 'Tus piernas y espalda pueden más, pero tus manos se abren.'
  }, {
    icon: <AlertTriangle className="w-8 h-8 text-neon-red" data-id="element-104" />,
    text: 'Usás straps porque no podés sostener',
    desc: 'Te volviste dependiente. Sin accesorios, tu fuerza real es la mitad.'
  }, {
    icon: <TrendingDown className="w-8 h-8 text-neon-red" data-id="element-105" />,
    text: 'Sentís que tu fuerza no se traduce',
    desc: 'Mucha masa muscular, pero un apretón de manos débil y falta de transferencia.'
  }];
  return <section className="py-24 bg-dark-800 relative border-t border-dark-700" data-id="element-106">
      <div className="container mx-auto px-4" data-id="element-107">
        <div className="max-w-4xl mx-auto" data-id="element-108">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-109">
            <h2 className="text-4xl md:text-6xl font-oswald font-bold text-white mb-6" data-id="element-110">
              EL ESLABÓN <span className="text-neon-red" data-id="element-111">DÉBIL</span>
            </h2>
            <p className="text-xl text-gray-400 font-inter" data-id="element-112">
              Conocés esta frustración. Llegás al límite no por falta de fuerza
              global, sino porque tus manos te traicionan.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-113">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="bg-dark-900 p-8 rounded-xl border border-dark-700 hover:border-neon-red/50 transition-colors group" data-id="element-114">
                <div className="mb-6 p-4 bg-dark-800 rounded-full inline-block group-hover:scale-110 transition-transform" data-id="element-115">
                  {point.icon}
                </div>
                <h3 className="text-xl font-oswald font-bold text-white mb-3 uppercase" data-id="element-116">
                  {point.text}
                </h3>
                <p className="text-gray-400 font-inter text-sm" data-id="element-117">{point.desc}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-gradient-to-r from-dark-900 via-dark-800 to-dark-900 p-10 rounded-2xl border border-neon-cyan/20 text-center relative overflow-hidden" data-id="element-118">
            <div className="absolute inset-0 bg-neon-cyan/5 blur-2xl" data-id="element-119"></div>
            <h3 className="relative z-10 text-3xl md:text-5xl font-oswald font-bold text-white leading-tight" data-id="element-120">
              ESTO NO ES FALTA DE FUERZA.
              <br data-id="element-121" />
              <span className="text-neon-cyan text-shadow-neon" data-id="element-122">
                ES FALTA DE SISTEMA.
              </span>
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}